"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CotterJwtToken_1 = __importDefault(require("./CotterJwtToken"));
class CotterAccessToken extends CotterJwtToken_1.default {
    constructor(token) {
        super(token);
    }
    decodePayload() {
        var obj = super.decodePayload();
        return obj;
    }
    getAuthMethod() {
        return this.payload.authentication_method;
    }
    getScope() {
        return this.payload.scope;
    }
    getID() {
        return this.payload.sub;
    }
    getIdentifier() {
        return this.payload.identifier;
    }
    getClientUserID() {
        return this.payload.client_user_id;
    }
}
exports.default = CotterAccessToken;
